module.exports = __webpack_public_path__ + "static/media/Moroco_Portugal.0eecce3a.jpeg";